// import tanushreeImg from '../assets/members_imgs/tanushree_paidichetty_img.jpg';

export const MembersData = [
	{
		name: 'Arpana Shankar',
		description:
			'Arpana is a sophomore (10th grade) at APL Global School and one of the founding members of APL WIN. She is a violinist and loves exploring different styles of music. She is also interested in music production',
		emailID: 'arpananshankar@apl.edu.in',
	},
	{
		name: 'Hrishikesh Mohan',
		emailID: 'hrishikeshmohan@apl.edu.in',
		description:
			'A passionate dream of entrepreneurship has driven Hrishikesh, a sophomore at APL Global School (10th grade) and a founding member of APL WIN, all throughout his life. His willingness to help support and learn from society has driven him to make tangible changes and give back to society',
	},
	{
		name: 'Tanika Kapa',
		description:
			'Tanika is a sophomore (10th grade) at APL Global School and one of the founders of APL WIN. She has been dancing all her life and enjoys playing the violin. She is also an avid reader',
	},
	{
		name: 'Turiya Kalyan',
		description:
			"Turiya is one of the founding members of APL WIN. She is an avid reader and loves listening to music. Her aim through APL WIN is to promote women's rights and provide quality education to young girls",
	},
	{
		name: 'Vedanth Ramji',
		emailID: 'vedanthramji@apl.edu.in',
		description:
			'Vedanth is a sophomore (10th grade) at APL Global School. He is passionate about science and technology and believes in quality education for all. Vedanth hopes to be able to increase awareness about computer science in specially-abled children and children from rural areas through APL WIN. He is the developer of the APL WIN website and the tech lead',
	},
	// {
	// 	name: 'Vadhanaa Venkatakrishnan',
	// 	description:
	// 		'Vadhanaa Venkatakrishnan is a senior at APL Global School as well as the RCP (responsible citizen program) representative. Brought up in Dallas, Texas, she offers an alternate perspective to many of the problems tackled here at APL WIN. ',
	// 	emailID: 'vadhanaav@apl.edu.in',
	// },
	// {
	// 	name: 'Tanushree',
	// 	emailID: 'tanushree@apl.edu.in',
	// 	description:
	// 		'Tanushree is a senior (12th grade) at APL Global School, who loves singing; be it classical or western. She is a CSTD certified jazz dancer, and has also learnt many other dance styles like hiphop and breaking. Tanushree is passionate about helping people',
	// },
	// {
	// 	name: 'Mayuri',
	// 	description:
	// 		'Mayuri is a trilingual freshman (9th grade) at APL Global School, who speaks Tamil, English and Spanish. She loves reading and classical dance and enjoys debating',
	// 	emailID: 'mayurirajarajansangeetha@apl.edu.in',
	// },
	// {
	// 	name: 'Akshara Periyasamy',
	// 	description:
	// 		'Akshara Periyasamy is the RCP for grade 9 at APL Global school. She loves singing and music. She has also been learning classical dance for about 8 years and has participated in many competitions. She is into research about the environment',
	// 	emailID: 'aksharaperiyasamy@apl.edu.in',
	// },
	// {
	// 	name: 'Maryam Taher',
	// 	description:
	// 		'Maryam is a freshman (grade 9) at APL Global School. She enjoys playing football and basketball and loves cooking.',
	// },
	// {
	// 	name: 'Aatreyi Ganguli',
	// 	description:
	// 		'Aatreyi is a junior (11th grade) at APL Global School. She is deeply passionate about helping society and making the world a better place. Her hobbies include music and garderning',
	// },
	// {
	// 	name: 'Saahil',
	// 	description:
	// 		'Saahil is a sophomore (10th grade) at APL Global School. He loves playing football and analyzing the current economic and political state of the world.',
	// },
	// {
	// 	name: 'Abhijith',
	// 	description:
	// 		'Abhijith is a senior (12th grade) at APL Global School. He enjoys building things from kayaks to bicycles using scrap material and is an avid cricket fan. Abhijit hopes to make quality education available to all through APL WIN',
	// },
	// {
	// 	name: 'Sarvesh',
	// 	description:
	// 		"Sarvesh is an avid contributor to the community around him. He's been volunteering at blue cross for the last 4 years, with 250+ hours to his name, and has been involved in multiple fundraising events. He's enthusiastic about art and music and believes a further expression of both fields in our community could leave a positive feedback",
	// },
	// {
	// 	name: 'Anirudh',
	// 	description:
	// 		'Anirudh is a vibrant student who never passes up an opportunity to lend a hand. He always seems to have the ability to make people laugh to terrible jokes. He is a smart student who takes an interest about answering tough questions!',
	// },
	// {
	// 	name: 'Sanjana',
	// 	description:
	// 		'Sanjana is a very hardworking student who never ceases to be kind and caring. She is always quite fun to talk too and as a  very motivated person, she thrives in sports and loves challenges that come her way.',
	// },
	// {
	// 	name: 'Anaghya',
	// 	description:
	// 		'Anaghya is a sophomore (10th grade) at APL Global school and the RCP secretary for grade 10. He is interested in Formula 1 and other sports. Through WIN, Anaghya would like to give back to society and help people',
	// },
	// {
	// 	name: 'Sandhya Girish',
	// 	description:
	// 		'I am Sandhya Girish, currently studying in grade 10. I am a voracious reader and love writing. My hobbies include swimming, dancing and learning about the human mind! I’m looking forward to playing my part in making the world a better place.',
	// },
];
